import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { styled, Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, WIDGET_SPACE } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';
import BrandclubPhoneInput from '../components/BrandclubPhoneInput/index.js';
import { sendTextCallback } from '../../utils/textMessage.js';
import { AnalyticsTrackingEvent } from '../../analytics/events.js';

var _a, _b, _c, _d;
// import { relative } from 'path';
var BrandclubRightDownloadContainer = styled(GenericContainer)((_a = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: WIDGET_SPACE,
        paddingBottom: WIDGET_SPACE,
        paddingLeft: '5%',
        paddingRight: '5%',
        boxSizing: 'border-box'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        backgroundColor: '#fff',
        padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        backgroundColor: '#fff',
        padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var OverviewContent = styled(Grid)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
            color: theme.palette.primary.main,
            width: '100%',
            position: 'relative',
            justifyContent: 'space-between',
            flexDirection: 'row',
            gap: '50px'
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            flexDirection: 'column',
            gap: '20px',
        },
        _b);
});
var InfoContainer = styled(Grid)({
    '.title': (_b = {
            fontSize: 43,
            fontWeight: 700,
            lineHeight: 1.2
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            fontSize: 26,
            textAlign: 'center',
            padding: '0 20px',
        },
        _b),
    '.subtitle': (_c = {
            marginTop: 20,
            lineHeight: 1.6,
            fontSize: 22,
            fontWeight: 500
        },
        _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            fontSize: 16,
            textAlign: 'center',
            padding: '0 20px',
        },
        _c),
});
var GetAppContainer = styled(Grid)((_d = {
        marginTop: 20,
        maxWidth: 500
    },
    _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        maxWidth: 400,
        marginTop: 0,
    },
    _d));
var BrandclubRightDownload = function (_a) {
    var _b;
    var trackingParams = _a.trackingParams, analyticsTrack = _a.analyticsTrack, mainEntity = _a.mainEntity, axios = _a.axios, useSearchParams = _a.useSearchParams, userProfile = _a.userProfile;
    var searchParams = useSearchParams()[0];
    var prefix = 'https://app.brandclub.com/';
    var referralCode = searchParams.get('referralCode') || '';
    var qrCodeUrl = referralCode ? "".concat(prefix, "?referralCode=").concat(referralCode) : prefix;
    var desktopView = useMediaQuery("(min-width:".concat(TABLET_SCREEN_SIZE, "px)"));
    return (React.createElement(BrandclubRightDownloadContainer, null,
        React.createElement(OverviewContent, { container: true, wrap: "nowrap", alignItems: 'center' },
            React.createElement(InfoContainer, { flex: 1 },
                React.createElement("div", { className: "title" }, "Enjoy exclusive perks"),
                React.createElement("div", { className: "subtitle" }, "Get members-only access to cash rewards, offers, and events. The best of ".concat((_b = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity) === null || _b === void 0 ? void 0 : _b.name, " \u2014tailored just for you."))),
            React.createElement(GetAppContainer, { container: true, flexDirection: 'row', wrap: "nowrap", gap: '15px', justifyContent: desktopView ? 'flex-start' : 'center' },
                React.createElement(BrandclubPhoneInput, { userProfile: userProfile, qrCodeUrl: qrCodeUrl, handleSendText: function (phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, sendTextCallback(phoneNumber, axios, mainEntity, analyticsTrack, trackingParams, AnalyticsTrackingEvent.WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK)];
                        });
                    }); } })))));
};

export { BrandclubRightDownload };
//# sourceMappingURL=index.js.map
